import * as THREE from "three";

/**
 * Gets the world space direction of a local axis from a model.
 * This accounts for the model's rotation and normalization (baseRotationX).
 */
export function getWorldAxisDirection(
  model: THREE.Object3D,
  axis: "x" | "y" | "z",
): THREE.Vector3 {
  // Update the model's world matrix to ensure it's current
  model.updateMatrixWorld(true);

  // Extract rotation from the world matrix
  const rotationMatrix = new THREE.Matrix4();
  rotationMatrix.extractRotation(model.matrixWorld);

  // Local axis directions in model space
  let localAxis: THREE.Vector3;
  if (axis === "x") {
    localAxis = new THREE.Vector3(1, 0, 0);
  } else if (axis === "y") {
    localAxis = new THREE.Vector3(0, 1, 0);
  } else {
    localAxis = new THREE.Vector3(0, 0, 1);
  }

  // Transform local axis to world space
  return localAxis.applyMatrix4(rotationMatrix).normalize();
}
